import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  title: {
    id: 'home.title',
    defaultMessage: 'Informasi',
  },
  email: {
    id: 'home.label.email',
    defaultMessage: 'Alamat Email',
  },
  role: {
    id: 'home.label.role',
    defaultMessage: 'Role',
  },
  username: {
    id: 'home.label.username',
    defaultMessage: 'Username',
  },
  userId: {
    id: 'home.label.userId',
    defaultMessage: 'User ID',
  },
  orgId: {
    id: 'home.label.orgId',
    defaultMessage: 'Company ID',
  },
  name: {
    id: 'home.label.name',
    defaultMessage: 'Nama',
  },
  address: {
    id: 'home.label.address',
    defaultMessage: 'Alamat',
  },
  owner: {
    id: 'home.label.owner',
    defaultMessage: 'Owner',
  },
});
